$('.formtabs').each(function () {
    const thisElement = $(this);
    const tabTrigger = '.formtabs-tab';
    const tabPanel = '.formtabs-panel';
    const findTabTrigger = thisElement.find(tabTrigger);
    const findTabPanel = thisElement.find(tabPanel);

    const removeActiveStates = (el) => {
        if (el === tabTrigger + '.__active') {
            thisElement.find(el).attr('aria-selected', false);
        } else {
            thisElement.find(el).attr('aria-expanded', false);
        }

        thisElement.find(el).removeClass('__active');
    };

    const setActiveState = (el, type) => {
        thisElement.find(el).addClass('__active');

        if (type === 'trigger') {
            thisElement.find(el).attr('aria-selected', true);
        } else {
            thisElement.find(el).attr('aria-expanded', true);
        }
    };

    // set first tab trigger and panel on page load
    const firstTabTrigger = findTabTrigger.first();
    const firstTabPanel = findTabPanel.first();
    setActiveState(firstTabPanel);
    setActiveState(firstTabTrigger, 'trigger');

    findTabTrigger.click(function (e) {
        e.preventDefault();
        const dataSet = $(this).data('set');

        removeActiveStates(tabTrigger + '.__active');
        setActiveState($(this), 'trigger');

        removeActiveStates(tabPanel + '.__active')
        setActiveState(tabPanel + `[data-set=${dataSet}]`)
    })
});